// extracted by mini-css-extract-plugin
export default {"cls1":"u1F1ivHd0zFT5EJG04Sh","cls2":"FJQnMGW_BazXkVXtnjb1 u1F1ivHd0zFT5EJG04Sh"};